import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailsCardLayoutComponent } from './details-card-layout.component';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular';

import {
  faPenToSquare,
  faTrashCan,
  faEllipsisStrokeVertical
} from '@fortawesome/pro-light-svg-icons';

const icons: IconDefinition[] = [
  faPenToSquare,
  faTrashCan,
  faEllipsisStrokeVertical
]

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FontAwesomeModule
  ],
  declarations: [DetailsCardLayoutComponent],
  exports: [DetailsCardLayoutComponent]
})
export class DetailsCardLayoutModule {
  private readonly _lib: FaIconLibrary = inject(FaIconLibrary);

  constructor() {
    this._lib.addIcons(...icons);
  }
}
